/*
 * @Descripttion: 基础配置store
 * @version:
 * @Author:
 * @Date:
 */
import { defineStore } from 'pinia'
// 动态导入图片
import rlinkHeaderLogo from '@/assets/image/x-logo.png'
import smallLogo from '@/assets/image/p-logo.png'
// import backgroundImage from '@/assets/image/login-l-bg-zip.png'
import backgroundImage from '@/assets/image/bg-basic.png'

// 设置默认的基础配置信息
const defaultBaseConfigInfo = {
    // image:rlinkHeaderLogo,
    // smallLogo: smallLogo,
    // systemName: '智慧园区管理平台',
    // backgroundImage:backgroundImage,
    image:'',
    smallLogo: '',
    systemName: '',
    backgroundImage:'',
    systemNameShow: false,
    logoShow: false,
    smallLogoShow: false,
}

export const basicConfigStore = defineStore({
    id: 'basic-config-store',
    state: () => ({
        // 配置信息，设置默认值
        configInfo: defaultBaseConfigInfo,
    }),
    getters: {
        getconfigInfoMation() {
            return this.configInfo
        },
    },
    actions: {
        /**
         * @function 保存配置新信息
         * @param val
         */
        setConfigInfo(val) {
            this.configInfo = val
        },
    },
})    